module.exports = __webpack_public_path__ + "static/img/callNone.0d0c0179.png";